import type { Element, Piece } from "./model/board";

export const ENVIRONMENTS = [
  "emerald-ruins-backdrop",
  "autumn-orchard-backdrop",
  "frozen-cliffs-backdrop",
  "desert-temple-backdrop",
  "moonlit-grove-backdrop",
] as const;

const ENVIRONMENT_LEVELS = [1, 20, 40, 80, 160] as const;

export function environmentTexture(level: number): typeof ENVIRONMENTS[number] {
  // Each milestone opens a new painting; the final biome lasts indefinitely.
  let chapter = 0;
  for (let i = 1; i < ENVIRONMENT_LEVELS.length; i++) {
    if (level >= ENVIRONMENT_LEVELS[i]) chapter = i;
  }
  return ENVIRONMENTS[chapter];
}

export const BOARD_TEXTURES = {
  backdrop: ENVIRONMENTS[0],
  tile: "stone-tile",
} as const;

export const UI_TEXTURES = { battleFrame: "battle-button", battleEmblem: "battle-emblem" } as const;
export const EFFECT_TEXTURES = { fire: "fire-comet" } as const;

export const CHARACTER_TEXTURES: Record<Element, { small: string; medium: string; large: string }> = {
  fire: { small: "element-fire-small", medium: "element-fire-medium", large: "element-fire-large" },
  ice: { small: "element-ice-small", medium: "element-ice-medium", large: "element-ice-large" },
  lightning: { small: "element-lightning-small", medium: "element-lightning-medium", large: "element-lightning-large" },
};

export function characterTexture(piece: Pick<Piece, "element" | "tier">): string {
  const size = piece.tier < 3 ? "small" : piece.tier < 5 ? "medium" : "large";
  return CHARACTER_TEXTURES[piece.element][size];
}

export const BOARD_ASSETS = [
  { key: CHARACTER_TEXTURES.fire.small, path: "assets/characters/fire-small.webp" },
  { key: CHARACTER_TEXTURES.fire.medium, path: "assets/characters/fire-medium.webp" },
  { key: CHARACTER_TEXTURES.fire.large, path: "assets/characters/fire-large.webp" },
  { key: CHARACTER_TEXTURES.ice.small, path: "assets/characters/ice-small.webp" },
  { key: CHARACTER_TEXTURES.ice.medium, path: "assets/characters/ice-medium.webp" },
  { key: CHARACTER_TEXTURES.ice.large, path: "assets/characters/ice-large.webp" },
  { key: CHARACTER_TEXTURES.lightning.small, path: "assets/characters/lightning-small.webp" },
  { key: CHARACTER_TEXTURES.lightning.medium, path: "assets/characters/lightning-medium.webp" },
  { key: CHARACTER_TEXTURES.lightning.large, path: "assets/characters/lightning-large.webp" },
  ...ENVIRONMENTS.map(key => ({ key, path: `assets/environments/${key}.webp` })),
  { key: BOARD_TEXTURES.tile, path: "assets/terrain/stone-tile.webp" },
  { key: UI_TEXTURES.battleFrame, path: "assets/ui/battle-button.webp" },
  { key: UI_TEXTURES.battleEmblem, path: "assets/ui/battle-emblem.webp" },
  { key: EFFECT_TEXTURES.fire, path: "assets/effects/fire-comet.webp" },
] as const;
